import { useEffect } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Las secciones crecen después del primer render (imágenes lazy, fuentes,
 * el reCAPTCHA del formulario) y las posiciones de ScrollTrigger quedan
 * desfasadas. Se recalculan cuando cambia el alto del documento.
 * Usarlo una vez por página con secciones cinemáticas.
 */
export default function useRefreshScrollTriggers() {
    useEffect(() => {
        let timeout;
        const ro = new ResizeObserver(() => {
            clearTimeout(timeout);
            timeout = setTimeout(() => ScrollTrigger.refresh(), 200);
        });
        ro.observe(document.body);
        return () => {
            clearTimeout(timeout);
            ro.disconnect();
        };
    }, []);
}
